import React, { FunctionComponent } from "react";
import { WeatherMultiCityParameters, WidgetLayoutOrientation } from "../../../../api/mosaicApi";

interface WeatherMultiCityWidgetListItemProps {
    parameters: WeatherMultiCityParameters;
    name?: string;
}

const getOrientationName = (orientation?: WidgetLayoutOrientation): string => {
    switch (orientation) {
        case WidgetLayoutOrientation.Horizontal:
            return 'Horizontal';
        case WidgetLayoutOrientation.Vertical:
            return 'Vertical';
        default:
            return 'Horizontal';
    }
};

export const WeatherMultiCityWidgetListItem: FunctionComponent<WeatherMultiCityWidgetListItemProps> = ({ parameters, name }) => {
    return (
        <>
            <p>Cities: {parameters.cities.join(', ')}</p>
            {name && <p>Name: {name}</p>}

            {/* Background Image */}
            {parameters.noBackground && <p>No Background: Yes</p>}
            {parameters.backgroundImageUrl && (
                <img
                    className="mosaic-img"
                    src={parameters.backgroundImageUrl}
                    alt="Background"
                    style={{ maxHeight: '60px', width: 'auto', objectFit: 'contain', marginBottom: '5px' }}
                />
            )}

            {/* Basic Settings */}
            {parameters.orientation !== undefined && <p>Orientation: {getOrientationName(parameters.orientation)}</p>}
            {parameters.updateIntervalMinutes !== undefined && <p>Update Interval: {parameters.updateIntervalMinutes} min</p>}

            {/* Colors */}
            {parameters.textColour && <p>Text Color: {parameters.textColour}</p>}
            {parameters.backgroundColour && <p>Background Color: {parameters.backgroundColour}</p>}

            {/* Font Sizes */}
            {parameters.cityNameFontSize !== undefined && <p>City Name Font Size: {parameters.cityNameFontSize}</p>}
            {parameters.weatherDescriptionFontSize !== undefined && <p>Description Font Size: {parameters.weatherDescriptionFontSize}</p>}
            {parameters.currentTemperatureFontSize !== undefined && <p>Temperature Font Size: {parameters.currentTemperatureFontSize}</p>}
            {parameters.windFontSize !== undefined && <p>Wind Font Size: {parameters.windFontSize}</p>}

            {/* Icon Sizes */}
            {parameters.currentIconSize !== undefined && <p>Current Icon Size: {parameters.currentIconSize}</p>}

            {/* Padding & Spacing */}
            {parameters.leftPadding !== undefined && <p>Left Padding: {parameters.leftPadding}</p>}
            {parameters.spaceBetweenCities !== undefined && <p>Space Between Cities: {parameters.spaceBetweenCities}</p>}
        </>
    );
};

export default WeatherMultiCityWidgetListItem;
